module.exports = __webpack_public_path__ + "img/camarao.ef584b12.svg";